module.exports = __webpack_public_path__ + "img/footerIcon_2.6efeb62.png";